
export const admin = {
  employeeHub: {
    title: "จัดการบุคลากร",
    invite: "เชิญพนักงาน",
    selfDeleteError: "คุณไม่สามารถลบบัญชีของตัวเองได้",
    deleteConfirm: "คุณแน่ใจหรือไม่ว่าต้องการลบผู้ใช้นี้?",
    edit: "แก้ไข",
    delete: "ลบ",
    sidebar: {
      list: "รายชื่อพนักงาน",
      timeCard: "บันทึกเวลาเข้างาน",
      hoursWorked: "สรุปชั่วโมงงาน"
    },
    headers: {
      employee: "ชื่อ-สกุล",
      email: "อีเมล",
      role: "ตำแหน่ง",
      pin: "รหัส PIN",
      status: "สถานะ",
      actions: "จัดการ",
      clockIn: "เข้างาน",
      clockOut: "ออกงาน",
      duration: "ระยะเวลา (ชม.)",
      totalHours: "รวมชั่วโมง"
    }
  },
  settings: {
    description: "ตั้งค่าทั่วไปของระบบและอุปกรณ์",
    general: "ทั่วไป",
    features: "เปิด/ปิด ฟีเจอร์",
    systemStatus: "สถานะระบบ",
    posDevicesPage: {
      title: "อุปกรณ์ POS",
      description: "จัดการจุดชำระเงินและการเชื่อมต่อเครื่องพิมพ์",
      addNew: "เพิ่มอุปกรณ์",
      table: {
        name: "ชื่ออุปกรณ์",
        store: "สาขา",
        status: "สถานะ",
        actions: "จัดการ"
      }
    },
    taxesPage: {
      title: "การตั้งค่าภาษี",
      description: "จัดการการตั้งค่าภาษีสำหรับร้านค้าของคุณ",
      enable: "เปิดใช้งานภาษี",
      taxName: "ชื่อภาษี",
      taxRate: "อัตราภาษี"
    },
    loyaltyPage: {
      title: "ตั้งค่าการสะสมแต้ม",
      description: "กำหนดอัตราการได้รับคะแนนสะสม",
      earnRateLabel: "อัตราการได้รับแต้ม",
      exampleTitle: "ตัวอย่างการคำนวณ",
      examplePurchase: "ลูกค้าซื้อสินค้า",
      examplePoints: "ได้รับแต้ม",
      relatedTitle: "จัดการของรางวัล",
      relatedLink: "ไปที่หน้าโปรโมชั่น"
    },
    featureToggles: {
      timeClock: {
        title: "ระบบตอกบัตร",
        description: "ติดตามเวลาการทำงานของพนักงาน"
      },
      lowStockNotifications: {
        title: "แจ้งเตือนสินค้าใกล้หมด",
        description: "แจ้งเตือนเมื่อสินค้าในสต็อกต่ำกว่าเกณฑ์"
      },
      negativeStockAlerts: {
        title: "แจ้งเตือนสต็อกติดลบ",
        description: "แจ้งเตือนเมื่อขายสินค้าที่ไม่มีในสต็อก"
      }
    }
  },
  reports: {
    loading: "กำลังสร้างรายงาน...",
    exportCsv: "ส่งออกเป็น CSV",
    empty: "ไม่มีข้อมูลในช่วงเวลานี้",
    filters: {
      employee: "พนักงาน",
      allEmployees: "พนักงานทั้งหมด"
    },
    sidebar: {
      salesSummary: "สรุปยอดขาย",
      salesByProduct: "ยอดขายตามสินค้า",
      salesByCategory: "ยอดขายตามหมวดหมู่",
      salesByEmployee: "ยอดขายตามพนักงาน",
      salesByPayment: "แยกตามการชำระเงิน",
      shifts: "ประวัติการปิดกะ",
      taxes: "รายงานภาษี",
      clinicalStats: "สถิติการรักษา (Clinical)",
      referralStats: "สถิติการส่งต่อ (Referral)"
    },
    headers: {
      grossSales: "ยอดขายรวม",
      netSales: "ยอดขายสุทธิ",
      discounts: "ส่วนลด",
      transactionCount: "จำนวนบิล",
      averageSale: "เฉลี่ยต่อบิล",
      product: "สินค้า",
      category: "หมวดหมู่",
      quantity: "จำนวน",
      itemsSold: "ชิ้นที่ขาย",
      employee: "พนักงาน",
      paymentMethod: "ช่องทาง",
      totalValue: "ยอดรวม",
      discountType: "ประเภทส่วนลด",
      uses: "จำนวนครั้ง",
      totalDiscount: "ส่วนลดรวม",
      date: "วันที่",
      taxableAmount: "ยอดคิดภาษี",
      taxAmount: "มูลค่าภาษี",
      cashier: "แคชเชียร์",
      openedAt: "เปิดกะ",
      closedAt: "ปิดกะ",
      startAmount: "เงินเริ่ม",
      expected: "ที่ควรมี",
      endAmount: "นับได้จริง",
      variance: "ผลต่าง"
    },
    clinical: {
      symptoms: "สถิติอาการผู้ป่วย (Symptoms)",
      doctorPerformance: "ประสิทธิภาพแพทย์ (Doctor Performance)"
    },
    referral: {
      title: "สถิติการส่งต่อผู้ป่วย (Referral Stats)",
      totalRequests: "คำขอทั้งหมด",
      totalApproved: "อนุมัติแล้ว",
      topSender: "ผู้ส่งยอดสูงสุด",
      table: {
        sender: "ร้านต้นทาง",
        total: "รวม",
        approved: "อนุมัติ",
        rejected: "ปฏิเสธ",
        pending: "รอ",
        rate: "อัตราอนุมัติ",
        lastActive: "ใช้งานล่าสุด"
      }
    }
  },
  auditLogs: {
    title: "ประวัติการใช้งาน (Audit Logs PDPA)",
    subtitle: "บันทึกความปลอดภัยและการเข้าถึงข้อมูล",
    filterUser: {
        all: "ผู้ใช้ทั้งหมด"
    },
    filterAction: {
        all: "ทุกการกระทำ",
        view: "ดูข้อมูล (View)",
        login: "เข้าสู่ระบบ (Login)",
        create: "สร้าง (Create)",
        update: "แก้ไข (Update)",
        delete: "ลบ (Delete)",
        sale: "ขาย (Sale)"
    },
    searchPlaceholder: "ค้นหาประวัติ...",
    export: "ส่งออก CSV",
    table: {
        timestamp: "เวลา",
        user: "ผู้ใช้",
        action: "การกระทำ",
        description: "รายละเอียด",
        data: "ข้อมูลดิบ"
    },
    pagination: {
        total: "ทั้งหมด: {{count}} รายการ"
    }
  }
};
